import { render, staticRenderFns } from "./TicketsChartAccess.vue?vue&type=template&id=63277c87&scoped=true&"
import script from "./TicketsChartAccess.vue?vue&type=script&lang=js&"
export * from "./TicketsChartAccess.vue?vue&type=script&lang=js&"
import style0 from "./TicketsChartAccess.vue?vue&type=style&index=0&id=63277c87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63277c87",
  null
  
)

export default component.exports